import K from "utilities/constants";
import { PageHeader } from "antd";
import LayoutCss from "../../layout/layout.module.scss";
import { ReportContainer } from "./reportContainer/reportContainer";

export const InternalReporting = () => {
  return (
    <>
      <PageHeader
        ghost={false}
        title="Internal Reporting"
        className={LayoutCss.appPageHeader}
      />
      <ReportContainer type={K.Clients.Reports.Type.Dashboard} />
    </>
  );
};
